import React from 'react';
const Live = React.lazy(() => import('./views/Device/Live'));
const Upload = React.lazy(() => import('./views/Device/Upload'));
const Report = React.lazy(() => import('./views/Device/PatientTable'));
// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [  
  { path: '/auth/live',exact: true, name:'Phân tích trực tuyến', component: Live},
  { path: '/auth/upload',exact: true, name:'Phân tích ngoại tuyến', component: Upload},
  { path: '/auth/report',exact: true, name:'Báo cáo', component: Report},  
  { path: '/',exact: true, name:'Live', component: Live},
];

export default routes;
